var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button, message, Modal, Table, Tag } from 'antd';
import * as React from 'react';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Page from 'src/shared/layout/Page';
import services from 'src/shared/services/services';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { history } from 'src/App';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.model = [];
        _this.selected = [];
        _this.refresh = function () {
            _this.loading = true;
            services.User.getAll().then(function (c) {
                _this.model = c;
                _this.loading = false;
            });
        };
        _this.delete = function (id) {
            Modal.confirm({
                title: 'Veriyi silmek istediğinizden emin misiniz?',
                onOk: function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.loading = true;
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, , 3, 4]);
                                return [4 /*yield*/, services.User.delete(id)];
                            case 2:
                                _a.sent();
                                message.success('Veri silindi..');
                                return [3 /*break*/, 4];
                            case 3:
                                this.loading = false;
                                return [7 /*endfinally*/];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); }
            });
        };
        return _this;
    }
    default_1.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, services.User.getAll()];
                    case 1:
                        _a.model = _b.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    default_1.prototype.render = function () {
        var _this = this;
        return (React.createElement(Page, { buttons: React.createElement(Fragment, null,
                React.createElement(Fragment, null,
                    React.createElement(Button, { icon: "plus", type: "primary", onClick: function () { return history.push('/users/user/new'); } }, "Ekle"),
                    React.createElement(Button, { icon: "reload", onClick: this.refresh }, "Yenile"))), breadcrumbs: [{ link: '/users/user', text: 'Kullanıcılar' }], title: "Kullan\u0131c\u0131lar", loading: this.loading },
            React.createElement("div", { className: "card-header bg-transparent" },
                React.createElement("span", { className: "card-title font-weight-semibold" }, "Kullan\u0131c\u0131 Listesi")),
            React.createElement("div", { className: "card-body" },
                React.createElement(Table, { dataSource: this.model, size: "small", rowKey: "id", rowSelection: {
                        onChange: function (_, rows) {
                            _this.selected = rows;
                        }
                    } },
                    React.createElement(Table.Column, { dataIndex: "userName", title: "KULLANICI ADI" }),
                    React.createElement(Table.Column, { dataIndex: "name", title: "ADI SOYADI" }),
                    React.createElement(Table.Column, { dataIndex: "email", title: "EMA\u0130L" }),
                    React.createElement(Table.Column, { dataIndex: "phoneNumber", title: "TELEFON" }),
                    React.createElement(Table.Column, { dataIndex: "roles", title: "YETK\u0130", render: function (c) { return c.join(', '); } }),
                    React.createElement(Table.Column, { dataIndex: "isActive", title: "DURUM", render: function (c) { return (c ? React.createElement(Tag, { color: "green" }, "Aktif") : React.createElement(Tag, { color: "red" }, "Pasif")); } }),
                    React.createElement(Table.Column, { dataIndex: "id", fixed: "right", width: 100, title: "\u0130\u015ELEM", render: function (id) { return (React.createElement(Fragment, null,
                            React.createElement(Link, { to: '/users/user/' + id }, "D\u00FCzenle"),
                            " ",
                            ' | ',
                            React.createElement("a", { href: "javascript:void(0);", onClick: function () { return _this.delete(id); } }, "Sil"))); } })))));
    };
    __decorate([
        observable
    ], default_1.prototype, "loading", void 0);
    __decorate([
        observable
    ], default_1.prototype, "model", void 0);
    __decorate([
        observable
    ], default_1.prototype, "selected", void 0);
    default_1 = __decorate([
        observer
    ], default_1);
    return default_1;
}(React.Component));
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/app/users/user/List.tsx
// module id = 1285
// module chunks = 0